export type VrboPromotionStatus = 'ACTIVE' | 'INACTIVE'
export type VrboPromotionType = 'EARLY_BOOKING' | 'LAST_MINUTE' | 'MOBILE_ONLY' | 'MEMBER_ONLY' | 'NEW_LISTING_DISCOUNT'
export type VrboDiscountUnit = 'PERCENT' | 'AMOUNT'
export type VrboDiscountMode = 'single' | 'dayOfWeek' | 'tiered'
export type VrboMemberTier = 'BLUE' | 'SILVER' | 'GOLD' | 'PLATINUM'

export const DAYS_OF_WEEK = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'] as const
export type VrboDayOfWeek = typeof DAYS_OF_WEEK[number]

export const MEMBER_TIERS: VrboMemberTier[] = ['BLUE', 'SILVER', 'GOLD', 'PLATINUM']

// NEW_LISTING_DISCOUNT is managed through the join/withdraw flow instead
export const CREATABLE_PROMOTION_TYPES: { value: VrboPromotionType, text: string }[] = [
    { value: 'EARLY_BOOKING', text: 'Early Booking' },
    { value: 'LAST_MINUTE', text: 'Last Minute' },
    { value: 'MOBILE_ONLY', text: 'Mobile Only' },
    { value: 'MEMBER_ONLY', text: 'Member Only' },
]

export type VrboDiscountValue = {
    unit: VrboDiscountUnit
    value: string | number
}

export type VrboPromotion = {
    id: string
    name?: string | null
    promotionType: VrboPromotionType
    status: VrboPromotionStatus
    sellStatus?: 'EXPIRED' | 'CURRENT' | 'FUTURE' | null
    incentive?: {
        discountIncentive?: {
            applicabilityRules?: {
                applicableNights?: { applicableNight: number, recurring: boolean } | null
            } | null
            discount?: {
                single?: { singleDiscount: VrboDiscountValue, supplierDiscountId?: string | null } | null
                dayOfWeek?: ({ supplierDiscountId?: string | null } & Record<VrboDayOfWeek, VrboDiscountValue>) | null
                tiered?: {
                    tiers?: { memberTier: VrboMemberTier, discount: VrboDiscountValue, supplierDiscountId?: string | null }[] | null
                } | null
            } | null
        } | null
    } | null
    restrictions?: {
        audienceTarget?: (string | null)[] | null
        stayDurationRange?: { min?: number | null, max?: number | null } | null
        advanceBookingDaysRange?: { min?: number | null, max?: number | null } | null
        bookingLocalDateTimeRange?: { from?: string | null, to?: string | null } | null
        travelDateRange?: { from: string, to: string } | null
        sameDayBookingStartTime?: string | null
        blackoutDates?: { travelDateFrom: string, travelDateTo: string }[] | null
    } | null
}

export type VrboPromotionFormValues = {
    promotionType: VrboPromotionType | ''
    status: VrboPromotionStatus
    discountMode: VrboDiscountMode
    discountUnit: VrboDiscountUnit
    singleValue: string | number
    dayOfWeek: Record<VrboDayOfWeek, string | number>
    tiers: Record<VrboMemberTier, string | number>
    travelFrom: string
    travelTo: string
    blackoutDates: { from: string, to: string }[]
    stayMin: string | number
    stayMax: string | number
    advanceMin: string | number
    advanceMax: string | number
    bookingFrom: string
    bookingTo: string
    // raw JSON mode; these never go into the VRBO payload
    useJson: boolean
    jsonText: string
    // fields the form does not edit, kept so an update does not drop them
    extras: {
        audienceTarget?: string[]
        sameDayBookingStartTime?: string
        applicableNights?: { applicableNight: number, recurring: boolean }
    }
}
